// extracted by mini-css-extract-plugin
module.exports = {"root":"Logout__root___L6JcC","emoji":"Logout__emoji___SbFsw","WAVE":"Logout__WAVE___JIO1d"};